import { render, staticRenderFns } from "./AnalyticsHearingItemList.vue?vue&type=template&id=23dd5824&scoped=true"
import script from "./AnalyticsHearingItemList.vue?vue&type=script&lang=js"
export * from "./AnalyticsHearingItemList.vue?vue&type=script&lang=js"
import style0 from "./AnalyticsHearingItemList.vue?vue&type=style&index=0&id=23dd5824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dd5824",
  null
  
)

export default component.exports